export const useMainPageData = () => {
  const dataLayer = utilsMainDataLayer()

  const { fetchGlobalDataForContentType, localeGlobalContentData, labels, globalContentData } = useMainGlobalData()

  const {
    useAsyncDataWithQuery,
    useRelatedPagesAsyncDataWithQuery,
    useRelatedPagesAsyncData,
    useStandardAsyncData,
    onAfterAdyenData,
    onBeforeAdyenData,
    content,
    pageData
  } = usePageData('main', {
    layerMappers: dataLayer.mappers,
    layerFragments: dataLayer.fragments,
    fetchGlobalDataFunction: fetchGlobalDataForContentType
  })

  return {
    content,
    pageData,
    globalContentData,
    localeGlobalContentData,
    labels,
    onBeforeAdyenData,
    onAfterAdyenData,
    useAsyncDataWithQuery,
    useRelatedPagesAsyncDataWithQuery,
    useRelatedPagesAsyncData,
    useStandardAsyncData
  }
}
